export default {
  drawer: null,
  showTransactionFilters: false,
  userLoggedIn: false,
  userInfo: {}
}